import { Controller } from "@hotwired/stimulus"

// Bookmark icon: drop + fold + shadow animation on click. Saved state comes from server.
export default class extends Controller {
  run() {
    this.element.classList.add("icon-bookmark--saving")
    setTimeout(() => this.element.classList.remove("icon-bookmark--saving"), 350)
  }
}
